import { injectable, interfaces } from 'inversify';
import { LatLng } from 'leaflet';
import { action, makeObservable, observable } from 'mobx';
import { v4 } from 'uuid';

export interface IAnnotationUiStore {
  zoomLevel: number;
  minZoomLevel: number;
  maxZoomLevel: number;
  isImageLoading: boolean;
  isQueueRequestInProgress: boolean;
  cursorLatLng?: LatLng;
  readonly isInValidation: boolean;
  reactLeafletRenderFingerprint: string;
  isLeftMenuOpened: boolean;
  changeZoomLevel(zoom: number): void;
  changeIsImageLoading(isLoading: boolean): void;
  setCurrentCursorPosition(latlng?: LatLng): void;
  forceReRender(): void;
  setIsLeftMenuOpened(value: boolean): void;
  setIsInValidation(value: boolean): void;
}

export namespace IAnnotationUiStore {
  export const $: interfaces.ServiceIdentifier<IAnnotationUiStore> = Symbol('ANNOTATION_UI_STORE');
}

@injectable()
export class AnnotationUiStore implements IAnnotationUiStore {
  isImageLoading: boolean = true;

  isQueueRequestInProgress: boolean = false;

  cursorLatLng?: LatLng = undefined;

  zoomLevel: number = 100;

  isInValidation: boolean = false;

  minZoomLevel: number = 3;

  maxZoomLevel: number = 3000;

  reactLeafletRenderFingerprint: string = v4();

  isLeftMenuOpened: boolean = false;

  constructor() {
    makeObservable(this, {
      isImageLoading: observable,
      isQueueRequestInProgress: observable,
      zoomLevel: observable,
      isInValidation: observable,
      reactLeafletRenderFingerprint: observable,
      isLeftMenuOpened: observable,
      changeZoomLevel: action,
      changeIsImageLoading: action,
      forceReRender: action,
    });
  }

  changeZoomLevel(zoom: number): void {
    this.zoomLevel = zoom;
  }

  changeIsImageLoading(isLoading: boolean): void {
    this.isImageLoading = isLoading;
  }

  setCurrentCursorPosition(latlng?: LatLng): void {
    this.cursorLatLng = latlng;
  }

  forceReRender(): void {
    this.reactLeafletRenderFingerprint = v4();
  }

  setIsLeftMenuOpened(value: boolean): void {
    this.isLeftMenuOpened = value;
  }

  setIsInValidation(value: boolean): void {
    this.isInValidation = value;
  }
}
